import {
	ICrmeLeadHistoricoCleanDTO,
	ICrmeLeadHistoricoDTO,
	ICrmeLeadHistoricoFullDTO
} from '../models/happy-code-api.model';
import { baseFindList } from './base/base-find-list.service';
import { baseFind } from './base/base-find.service';

export const useLeadHistoricoService = () => {
	const resourceURL = 'crme/lead-historico';

	return {
		...baseFindList<ICrmeLeadHistoricoCleanDTO, ICrmeLeadHistoricoDTO, ICrmeLeadHistoricoFullDTO>(resourceURL),
		...baseFind<ICrmeLeadHistoricoCleanDTO, ICrmeLeadHistoricoDTO, ICrmeLeadHistoricoFullDTO>(resourceURL),
	};
};
